var map = {
	"./1/capa.png": 917,
	"./1/gif-1.gif": 321,
	"./1/gif-2.gif": 918,
	"./2/capa.png": 308,
	"./3/capa.png": 519,
	"./4/capa.png": 566,
	"./5/capa.png": 625,
	"./6/capa.png": 576,
	"./7/capa.png": 235,
	"./8/capa.png": 554,
	"assets/posts/1/capa.png": 917,
	"assets/posts/1/gif-1.gif": 321,
	"assets/posts/1/gif-2.gif": 918,
	"assets/posts/2/capa.png": 308,
	"assets/posts/3/capa.png": 519,
	"assets/posts/4/capa.png": 566,
	"assets/posts/5/capa.png": 625,
	"assets/posts/6/capa.png": 576,
	"assets/posts/7/capa.png": 235,
	"assets/posts/8/capa.png": 554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 880;